var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-completion"},[_c('small',[_vm._v(_vm._s(_vm.title)+_vm._s(_vm.progress)+"%")]),_c('div',{staticClass:"progress progress-mini"},[_c('div',{staticClass:"progress-bar",style:(`width: ${_vm.progress}%;`)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }